export const heroImages = {
  solar: {
    firstUrl: "images/checkout-success/slide_2.webp",
    secondUrl: "images/checkout-success/solar_2.webp"
  }
};

export const heroSliderImages = [
  "images/checkout-success/slide_1.webp",
  "images/checkout-success/slide_2.webp",
  "images/checkout-success/slide_3.webp",
  "images/checkout-success/slide_4.webp"
];
export const boilerSliderImages = [
  "images/checkout-success/boiler_1.webp",
  "images/checkout-success/boiler_2.webp",
  "images/checkout-success/boiler_3.webp"
];
